export default __webpack_public_path__ + "static/media/culture_EP7.9241a015.png";